import React from 'react';
import { Check } from 'lucide-react';
import { useT } from '../salesI18n';
import { STATUS_STYLES } from './StatusBadge';

const STEPS = ['new', 'visit_scheduled', 'measured', 'proposal_sent', 'won'];

export const StatusStepper = ({ status, onChange }) => {
  const { t } = useT();
  const isLost = status === 'lost';
  const idx = STEPS.indexOf(status);
  return (
    <div data-testid="lead-status-stepper" className="flex items-center gap-0 overflow-x-auto sales-kanban-scroll pb-2">
      {STEPS.map((s, i) => {
        const done = !isLost && i < idx;
        const active = s === status;
        const st = STATUS_STYLES[s];
        return (
          <React.Fragment key={s}>
            <button
              type="button"
              data-testid={`lead-stepper-${s}`}
              onClick={() => onChange?.(s)}
              className={`shrink-0 inline-flex items-center gap-1.5 rounded-full border px-3.5 h-9 text-xs font-semibold transition-all duration-200 ${active ? `${st.badge} ring-2 ring-offset-1 ring-teal-500/40 shadow-sm` : done ? 'bg-teal-600 border-teal-600 text-white' : 'bg-white/60 border-slate-200 text-slate-500 hover:bg-white hover:text-slate-800'}`}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : <span className={`h-2 w-2 rounded-full ${active ? st.dot : 'bg-slate-300'}`} />}
              {t.status[s]}
            </button>
            {i < STEPS.length - 1 && <span className={`h-0.5 w-5 shrink-0 rounded-full ${done ? 'bg-teal-500' : 'bg-slate-300/70'}`} />}
          </React.Fragment>
        );
      })}
      {isLost && <span data-testid="lead-stepper-lost" className={`ml-3 shrink-0 inline-flex items-center rounded-full border px-3.5 h-9 text-xs font-semibold ${STATUS_STYLES.lost.badge} ring-2 ring-offset-1 ring-red-400/40`}>{t.status.lost}</span>}
    </div>
  );
};
